export const titleFunction = (t, title) =>
  title ? `${t('default.wse.short')} - ${title}` : t('default.wse');
